import { useState } from 'react';
import { Location } from '../../domain/models/locations/Location';
import { ReactComponent as LikeLineIcon } from '../../icons/like.line.svg';
import { ReactComponent as LikeShapeIcon } from '../../icons/like.shape.svg';
import { ReactComponent as MapFillIcon } from '../../icons/map.fill.svg';
import { openNewTab } from '@pocapan/shared/utils/UIUtils';
import moveKakaoMap from '@pocapan/shared/utils/moveKakaoMap';
import ToggleLikeLocation from '../api/mutations/ToggleLikeLocation';

const place_map_icon = '/assets/icons/offlineLocation/kakao_place_map_icon.png';

const PlaceInformation = ({ pos, hasPadding = false }: { pos: Location; hasPadding?: boolean }) => {
  const handleLikedPlace = async (e: React.MouseEvent<HTMLDivElement>, locationId: string) => {
    // 이벤트 전파 중단하여 상위 div의 onMouseDown이 실행되지 않도록 함
    e.stopPropagation();

    const response = await ToggleLikeLocation(locationId);
    const data = await response.json();

    if (response?.ok) {
      setIsLikedPlace(data?.location?.isLiked);
    }
  };

  const [isLikedPlace, setIsLikedPlace] = useState(pos.isLiked);

  return (
    <div className={`flex flex-row justify-between items-center${hasPadding ? ' px-[16px]' : ''}`}>
      <div
        className="flex flex-col max-w-[calc(100%-96px)]"
        onMouseDown={() => openNewTab(`/locations/${pos.locationId}`)}
      >
        <div className="flex flex-row items-center">
          <MapFillIcon className="w-[14px] h-[14px] min-w-[14px] fill-onTheirty-light dark:fill-onTheirty-dark mr-[3px]" />
          <div className="text-[17px] text-main-light-2 dark:text-main-dark-2 font-semibold truncate whitespace-nowrap leading-[20px]">
            {`${pos.name}`}
          </div>
        </div>
        <div className="text-[13px] text-main-light-4 dark:text-main-dark-4 truncate mt-[5px] leading-[16px]">
          {pos.streetAddress}
        </div>
      </div>

      <div className="flex items-center space-x-[10px]">
        <div
          className="w-[32px] h-[32px] p-[8px] rounded-full border-[1px] border-solid border-separator-light-1 dark:border-separator-dark-1"
          onMouseDown={() => moveKakaoMap(pos.latitude, pos.longitude, pos.kakaoUid)}
        >
          <img src={place_map_icon} alt="place_map_icon" />
        </div>
        <div
          className="w-[32px] h-[32px] p-[7px] rounded-full border-[1px] border-solid border-separator-light-1 dark:border-separator-dark-1"
          onMouseDown={(e) => handleLikedPlace(e, pos.locationId)}
        >
          {!isLikedPlace ? (
            <LikeLineIcon className="fill-primary-light dark:fill-primary-dark" />
          ) : (
            <LikeShapeIcon className="fill-[url(#gradient)]" />
          )}
        </div>
      </div>
    </div>
  );
};

export default PlaceInformation;
